import { BaseOption } from './base-option';

export class ComparabilityOption extends BaseOption { }
